/** Canonical brand / NAP for EEAT + schema consistency across pages. */
export const BRAND = {
  name: 'Trunggian247',
  legalName: 'Trung Gian 247',
  alternateNames: ['Trung Gian 247', 'GDTG'],
  url: 'https://trunggian247.com',
  logo: 'https://trunggian247.com/logo512.svg',
  description:
    'Nền tảng ký quỹ (escrow) trực tuyến tại Việt Nam. Bảo vệ người mua và người bán, thanh toán VND/USDT, phí khoảng 3%, hỗ trợ tranh chấp khoảng 48 giờ.',
  email: 'support.trunggian247com@gmail.com',
  telegram: 'https://t.me/trunggian247com',
  telegramHandle: '@trunggian247com',
  facebook: 'https://www.facebook.com/trunggian247com',
  areaServed: 'VN',
  feeNote: 'khoảng 3%',
  disputeNote: 'khoảng 48 giờ',
  serviceType: 'Online escrow / ký quỹ — không phải ngân hàng',
};

export const ORGANIZATION_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: BRAND.name,
  alternateName: BRAND.alternateNames,
  url: BRAND.url,
  logo: BRAND.logo,
  description: BRAND.description,
  email: BRAND.email,
  sameAs: [BRAND.facebook, BRAND.telegram],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    email: BRAND.email,
    availableLanguage: ['Vietnamese'],
    hoursAvailable: 'Mo-Su 00:00-24:00',
    url: BRAND.telegram,
  },
  areaServed: BRAND.areaServed,
  knowsAbout: [
    'giao dịch trung gian',
    'escrow',
    'ký quỹ online',
    'USDT P2P',
    'mua bán domain',
  ],
};
